export const numberToReadable = (num: number, maxDigits?: number) => {
    return num.toLocaleString('ru', { maximumFractionDigits: maxDigits || 0 })
}